// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/app/components/layout/ChannelItem.module.css';
import {useTextOverflow} from '@app/features/app/hooks/useTextOverflow';
import {Tooltip} from '@app/features/ui/tooltip/Tooltip';
import {clsx} from 'clsx';
import {observer} from 'mobx-react-lite';
import type React from 'react';
import {useRef} from 'react';

interface ChannelItemContentProps {
	icon?: React.ReactNode;
	name: string;
	actions?: React.ReactNode;
	isCategory?: boolean;
	nameClassName?: string;
}
export const ChannelItemContent: React.FC<ChannelItemContentProps> = observer(
	({icon, name, actions, isCategory = false, nameClassName}) => {
		const nameRef = useRef<HTMLSpanElement>(null);
		const isNameOverflowing = useTextOverflow(nameRef);
		if (isCategory) {
			return (
				<>
					<div className={styles.categoryContent}>
						<Tooltip text={isNameOverflowing && name ? name : ''}>
							<span ref={nameRef} className={clsx(styles.categoryName, nameClassName)}>
								{name}
							</span>
						</Tooltip>
					</div>
					{actions && <div className={styles.channelItemActions}>{actions}</div>}
				</>
			);
		}
		return (
			<>
				{icon && (
					<Tooltip text={name}>
						<div>{icon}</div>
					</Tooltip>
				)}
				<Tooltip text={isNameOverflowing && name ? name : ''}>
					<span ref={nameRef} className={clsx(styles.channelName, nameClassName)}>
						{name}
					</span>
				</Tooltip>
				{actions && <div className={styles.channelItemActions}>{actions}</div>}
			</>
		);
	},
);
